export default "images/hypertattoo_logo.png";